import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";


// notifications/get-unviewed
export const observedCropApi = createApi({
  reducerPath: "observedCropApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/observed-crop/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    createObservedCrop: builder.mutation({
      query: (data) => ({
        url: "create",
        body: data,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "ObservedPest", id: "List" },
        { type: "ObservedPest", id: (id) => id },
      ],
    }),
    getAllObservedPest : builder.query({
      query: (id) => ({
        url: `notifications/get/${id}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "ObservedPest", id: "List" },
        ...(result ?? []).map((ObservedPest) => ({ type: "ObservedPest", id: ObservedPest?.id })),
      ],
    }),
    getUnViewedNotifications : builder.query({
      query: (id) => ({
        url: `notifications/get-unviewed/${id}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "ObservedPest", id: "List" },
        ...(result ?? []).map((ObservedPest) => ({ type: "ObservedPest", id: ObservedPest?.id })),
      ],
    }),
    getObservedPest : builder.query({
      query: (id) => ({
        url: `get/${id}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "ObservedPest", id: "List" },
        ...(result ?? []).map((ObservedPest) => ({ type: "ObservedPest", id: ObservedPest?.id })),
      ],
    }),
    markViewedNotification : builder.mutation({
      query: (notificationId) => ({
        url: `notifications/mark-viewed/${notificationId}`,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "ObservedPest", id: "List" },
        { type: "ObservedPest", id: (id) => id },
      ],
    })
  }),
});

export const { useCreateObservedCropMutation, 
  useGetAllObservedPestQuery,
  useGetObservedPestQuery, 
  useMarkViewedNotificationMutation,
  useGetUnViewedNotificationsQuery
} = observedCropApi;

